import React, {Component} from 'react';
import ReactTable from 'react-table';
import TagsInput from 'react-tagsinput';
import {connect} from 'react-redux';
import range from 'lodash/range';
import find from 'lodash/find';
import nanoid from 'nanoid';
import {
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    InputGroup,
    InputGroupAddon
} from 'reactstrap';
import {I18n} from '../../I18n/components/attributes';
import 'react-table/react-table.css';
import 'react-tagsinput/react-tagsinput.css';
import './attributes.css';

import {
    fetchAttributes,
    saveNewAttribute,
    updateOldAttribute,
    filteringAttr,
    deleteAttr
} from '../../actions/attributesActions';
import {closeAlert} from '../../actions/commonsActions';

import {COMPANIESMODALVIEWS, MEMBERSMODALVIEWS, PAGINATION_LIST_SIZE} from '../../helpers/constants';
import MembersList from "../Stores/Stores";
import LinkedCompaniesList from "../LinkedCompaniesList/LinkedCompaniesList";
import {fetchCompanies} from '../../actions/companyActions';
import Pagination from '../Pagination/Pagination';

class Attributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            newAttribute: {
                id: null,
                name: '',
                type: 'APK',
                valueType: 'STRING',
                defaultValue: '',
                permittedValues: [],
                xpathMapping: '',
                editableByCompany: false,
                visibleForCompanies: [],
                comments: '',
                label: ''
            },
            attributes: {},
            isOkModal: false,
            selectedCompany: "",

            isCompaniesModalShown: false,
            selectedAttribute: null,
            companiesModalView: COMPANIESMODALVIEWS.ADD,
            isOkRemoveCompanyModal: false,

            currentPage: 0,
            paginatedList: [],

            filter: []
        };

    }

    componentDidMount () {
        (async () => {
            await this.props.fetchAttributes();
            await this.props.fetchCompanies(false);
        })();
    }

    toggleCompaniesModal = () => {
        this.setState(state => ({
            isCompaniesModalShown: !state.isCompaniesModalShown
        }));
    };

    removeAttributeCompanies = company => {
        const attr = Object.assign({}, this.state.newAttribute);
        attr.visibleForCompanies = attr.visibleForCompanies.filter(id => id !== company.id);
        this.setState({
            newAttribute: attr,
            selectedCompany: ''
        }, () => {
        })
    };


    changeCompanyListView = view => {
        this.setState({
            companiesModalView: view
        }, () => {
            this.toggleCompaniesModal();
        });
    };

    isOkRemoveCompanyModalToggle = company => {
        this.setState(state => ({
            isOkRemoveCompanyModal: !state.isOkRemoveCompanyModal,
            selectedCompany: company
        }));
    };

    onFilterClick = name => {
        return event => {
            const value  = event.target.value;
            this.setState(state => {
                const filteredElemIndex = state.filter.findIndex(item => item.name === name);
                let filters = [...state.filter];
                if (filteredElemIndex !== -1) {
                    if (value && value !== '') {
                        filters[filteredElemIndex].name = name;
                        filters[filteredElemIndex].value = value;
                    } else {
                        filters = filters.filter(elem => elem.name !== name);
                    }
                } else {
                    filters = [...state.filter, {name : name, value: value}]
                }
                return {
                    filter: filters
                }
            }, () => {
                this.props.filteringAttr(this.state.filter);
            })
        }
    };

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    clearNewAttributeState = () => {
        this.setState({
            newAttribute: {
                id: null,
                name: '',
                type: 'APK',
                valueType: 'STRING',
                defaultValue: '',
                permittedValues: [],
                xpathMapping: '',
                editableByCompany: false,
                visibleForCompanies: [],
                comments: '',
                label: ''
            },
            activeAttrId: null,
            selectedCompany: "",
        });
    };

    addNewAttribute = () => {
        const newAttribute = {...this.state.newAttribute};
        newAttribute.id = 'input' + nanoid();
        return this.props.saveNewAttribute(newAttribute)
    };

    updateAttribute = () => {
        const oldAttribute = {...this.state.newAttribute};
        return this.props.updateOldAttribute(oldAttribute)
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        let attributes = [...this.props.attributes] || [];
        try {
            if (attributes.filter(obj => obj.id === this.state.newAttribute.id).length === 0) {
                const newAttribute = await this.addNewAttribute();
                if (this.state.filter && this.state.filter.length) {
                    await this.props.fetchAttributes({filter: this.state.filter})
                } else {
                    await this.props.fetchAttributes();
                }
                this.toggle();
            } else {
                const attribute = await this.updateAttribute();
                this.clearNewAttributeState();
                if (this.state.filter && this.state.filter.length) {
                    await this.props.fetchAttributes({filter: this.state.filter})
                } else {
                    await this.props.fetchAttributes();
                }
                this.toggle();
            }
        } catch (error) {
            console.log(error)
            throw new Error(error.statusText)
        }
    };

    onCompanySelect = event => {
        const value = event.target.value;
        this.setState({
            selectedCompany: value
        })
    };

    onCompanyAdd = () => {
        const attr = Object.assign({}, this.state.newAttribute);
        attr.visibleForCompanies = [...attr.visibleForCompanies, +this.state.selectedCompany];
        this.setState({
            newAttribute: attr,
            selectedCompany: ''
        }, () => {
        })
    };

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.value;
        this.setState(state => ({
            newAttribute: Object.keys(state.newAttribute).reduce((res, key) => {
                if (key === name) {
                    let tempValue = null;
                    if (Array.isArray(state.newAttribute[key])) {
                        tempValue = value.split(',');
                        tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
                    } else {
                        tempValue = value;
                        if (key === 'editableByCompany') {
                            tempValue = !state.newAttribute[key];
                        }
                        if (key === 'valueType') {
                            state.newAttribute.defaultValue = '';
                        }
                        if (key === 'valueType' && value === 'BOOLEAN') {
                            state.newAttribute.permittedValues = [];
                            state.newAttribute.defaultValue = false;
                        }
                    }
                    res[key] = tempValue; //(Array.isArray(state.newAttribute[key])) ? value.split(',') : value;
                } else {
                    res[key] = state.newAttribute[key];
                }
                return res
            }, {})
        }), () => {
        });
    };

    addAttributeClick = () => {
        this.clearNewAttributeState();
        this.toggle();
    };

    handleRegularTags = regularTags => {
        const newAttribute = this.state.newAttribute;
        newAttribute.permittedValues = regularTags;
        this.setState({
            newAttribute
        });
    };

    renderDefaultAttributesValue = () => {
        let isFirstElementNotEmptyString = false;
        const firstElem = this.state.newAttribute.permittedValues[0];
        if (firstElem != null && typeof firstElem !== "undefined") {
            isFirstElementNotEmptyString = firstElem.trim();
        }
        if (isFirstElementNotEmptyString && this.state.newAttribute.valueType !== 'BOOLEAN') {
            return (
                <Input
                    type="select"
                    name="defaultValue"
                    id="defaultValue"
                    onChange={this.onInputChange}
                    value={this.state.newAttribute.defaultValue}>
                    <option value=""></option>
                    {
                        this.state.newAttribute.permittedValues ? (
                            this.state.newAttribute.permittedValues.map((elem, i) => {
                                return (
                                    <option value={elem} key={i}>{elem}</option>
                                )
                            })
                        ) : (
                            <option></option>
                        )
                    }
                </Input>
            )
        } else if (this.state.newAttribute.valueType === 'BOOLEAN') {
            return (
                <Input
                    type="select"
                    name="defaultValue"
                    id="defaultValue"
                    defaultValue={this.state.newAttribute.defaultValue}
                    onChange={this.onInputChange}
                >
                    <option value={false}>FALSE</option>
                    <option value={true}>TRUE</option>
                </Input>
            )
        } else {
            return (
                <Input
                    type="text"
                    name="defaultValue"
                    id="defaultValue"
                    defaultValue={this.state.newAttribute.defaultValue}
                    onChange={this.onInputChange}
                />
            )
        }
    };

    isOkModalToggle = id => {
        this.setState({
            isOkModal: !this.state.isOkModal,
            activeAttrId: id
        });
    };

    deleteAttribute = async () => {
        let attributeIndex = this.props.attributes.findIndex(elem => elem.id === this.state.activeAttrId);
        if (attributeIndex >= 0) {
            await this.props.deleteAttr(this.state.activeAttrId);
            if (this.state.filter && this.state.filter.length) {
                 await this.props.fetchAttributes({filter: this.state.filter})
            } else {
                 await this.props.fetchAttributes();
            }
            this.isOkModalToggle(null);
        }
    };

    render() {
        const {lang} = this.props;
        return (
            <div className='new-attr'>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Modal
                    className="companies-modal"
                    isOpen={this.state.isCompaniesModalShown}
                    toggle={this.toggleCompaniesModal}
                >
                    <ModalHeader toggle={this.toggleCompaniesModal}>
                        {this.state.companiesModalView === COMPANIESMODALVIEWS.REMOVE ? `${I18n[lang].companiesRemove}` : (
                            this.state.companiesModalView === COMPANIESMODALVIEWS.ADD ? `${I18n[lang].companiesAdd}` :
                                this.state.companiesModalView === COMPANIESMODALVIEWS.VIEW ? `${I18n[lang].companiesList}` : ''
                        )}
                    </ModalHeader>
                    <ModalBody>
                        <LinkedCompaniesList
                            companies={this.props.companies}
                            view={this.state.companiesModalView}
                            removeCompanies={this.removeAttributeCompanies}
                            attributeCompanies={this.state.newAttribute.visibleForCompanies}
                        />
                    </ModalBody>
                </Modal>
                <Modal className="del-modal del-modal__attributes" isOpen={this.state.isOkModal} toggle={this.isOkModalToggle}>
                    <ModalHeader>{I18n[lang].modal.sure}</ModalHeader>
                    <ModalBody>
                        <Button color="secondary" className="ml-1" onClick={() => {
                            this.isOkModalToggle(null)
                        }}>{I18n[lang].modal.cancel}</Button>
                        <Button color="danger" className="ml-1" onClick={this.deleteAttribute}>{I18n[lang].modal.delete}</Button>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>{I18n[lang].modal.add_edit}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleSubmit} className='new-attr__form'>
                            <Input type="hidden" name="id" id="id" defaultValue={this.state.newAttribute.id}/>
                            <FormGroup>
                                <Label for="name">{I18n[lang].modal.labelName}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    id="name"
                                    defaultValue={this.state.newAttribute.name}
                                    onChange={this.onInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="type">{I18n[lang].modal.labelView}</Label>
                                <Input
                                    type="select"
                                    name="type"
                                    id="type"
                                    defaultValue={this.state.newAttribute.type || "APK"}
                                    onChange={this.onInputChange}
                                >
                                    <option value="APK">APK</option>
                                    <option value="MOBILE_APP">MOBILE_APP</option>
                                    <option value="COMPANY">COMPANY</option>
                                    <option value="USER">USER</option>
                                    <option value="RETAIL_BUNDLE">RETAIL_BUNDLE</option>
                                    <option value="RETAIL_SALES_POINT">RETAIL_SALES_POINT</option>
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="valueType">{I18n[lang].modal.labelType}</Label>
                                <Input
                                    type="select"
                                    name="valueType"
                                    id="valueType"
                                    defaultValue={this.state.newAttribute.valueType}
                                    onChange={this.onInputChange}
                                >
                                    <option value="STRING">STRING</option>
                                    <option value="BOOLEAN">BOOLEAN</option>
                                    <option value="INT">INT</option>
                                    <option value="BYTE">BYTE</option>
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="defaultValue">{I18n[lang].modal.defaultValue}</Label>
                                {this.renderDefaultAttributesValue()}
                            </FormGroup>
                            <FormGroup>
                                {
                                    this.state.newAttribute.valueType !== 'BOOLEAN' ? (
                                        <div>
                                            <Label for="permittedValues">{I18n[lang].modal.permittedValues}</Label>
                                            <TagsInput
                                                inputProps={{
                                                    placeholder: `${I18n[lang].modal.permittedPlaceholder}`
                                                }}
                                                value={this.state.newAttribute.permittedValues}
                                                onChange={this.handleRegularTags}
                                                tagProps={{className: "react-tagsinput-tag bg-info text-white rounded"}}
                                            />
                                        </div>
                                    ) : ""
                                }

                            </FormGroup>
                            <FormGroup>
                                {
                                    this.state.newAttribute.type !== 'USER' ? (
                                        <div>
                                            <Label for="xpathMapping">{I18n[lang].modal.mapping}</Label>
                                            <Input
                                                type="text"
                                                name="xpathMapping"
                                                id="xpathMapping"
                                                defaultValue={this.state.newAttribute.xpathMapping}
                                                onChange={this.onInputChange}
                                            />
                                        </div>
                                    ) : ""
                                }
                            </FormGroup>
                            <FormGroup>
                                <Label for="comments">{I18n[lang].modal.comments}</Label>
                                <Input
                                    type="textarea" rows="3"
                                    name="comments"
                                    id="comments"
                                    defaultValue={this.state.newAttribute.comments}
                                    onChange={this.onInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="label">{I18n[lang].modal.label}</Label>
                                <Input
                                    type="text"
                                    name="label"
                                    id="label"
                                    defaultValue={this.state.newAttribute.label}
                                    onChange={this.onInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="editableByCompany">{I18n[lang].modal.editableByCompany}</Label>
                                <Input
                                    type="checkbox"
                                    name="editableByCompany"
                                    id="editableByCompany"
                                    className="new-attr__checkbox"
                                    checked={this.state.newAttribute.editableByCompany}
                                    onChange={this.onInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="company-list-title">{I18n[lang].modal.companyList}</Label><br/>
                                <Button
                                    title="Компании"
                                    type="button"
                                    onClick={() => {
                                        this.changeCompanyListView(COMPANIESMODALVIEWS.REMOVE);
                                    }}
                                    color="primary"
                                    size="sm"
                                    round="true"
                                    icon="true"
                                ><i className="fas fa-building"/></Button>
                                <InputGroup className="new-attr__custom-select">
                                    <Input type="select" className="custom-select"
                                       value={this.state.selectedCompany}
                                       onChange={this.onCompanySelect}
                                    >
                                        <option value="">{I18n[lang].modal.selectedByCompany}</option>
                                        {
                                            this.props.companies.map(company => {
                                                if (!this.state.newAttribute.visibleForCompanies.includes(company.id)) {
                                                    return <option key={company.id}
                                                                   value={company.id}
                                                            >{company.name}</option>
                                                }
                                            })
                                        }
                                    </Input>
                                    <InputGroupAddon addonType="append">
                                        <Button
                                            type="button"
                                            color="primary"
                                            onClick={this.onCompanyAdd}
                                        >{I18n[lang].modal.addCompany}</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className='new-attr__buttons'>
                                <Button color="secondary" className="ml-1" onClick={this.toggle}>{I18n[lang].modal.cancel}</Button>
                                <Button color="primary" type="submit">{I18n[lang].modal.save}</Button>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                </Modal>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[lang].title}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <div className="attr___top">
                            <Form className="attr__searchform">
                                <Input
                                    className="attr__search"
                                    type="text"
                                    name="search"
                                    id="search"
                                    placeholder={I18n[lang].searchPlaceholder}
                                    onChange={this.onFilterClick('name')}
                                />
                                <Input
                                    className="attr__filter"
                                    type="select"
                                    name="type-filter"
                                    id="type-filter"
                                    onChange={this.onFilterClick('type')}
                                >
                                    <option value="">{I18n[lang].allViews}</option>
                                    <option value="APK">APK</option>
                                    <option value="MOBILE_APP">MOBILE_APP</option>
                                    <option value="COMPANY">COMPANY</option>
                                    <option value="USER">USER</option>
                                    <option value="RETAIL_BUNDLE">RETAIL_BUNDLE</option>
                                    <option value="RETAIL_SALES_POINT">RETAIL_SALES_POINT</option>
                                </Input>
                            </Form>
                            <Button color="primary" type="button" onClick={this.addAttributeClick}>{I18n[lang].addAttr}</Button>
                        </div>
                        {
                            (() => {
                                const {loading} = this.props;
                                if (loading) {
                                    return <div className="loading">Loading...</div>;
                                } else {
                                    const attrs = this.props.filteredAttrs || this.props.attributes;
                                    const tableData = attrs.map((item, index) => {
                                        return {
                                            //index: index + 1,
                                            id: item.id,
                                            name: item.name,
                                            type: item.type,
                                            valueType: item.valueType,
                                            defaultValue: item.defaultValue,
                                            permittedValues: item.permittedValues,
                                            editableByCompany: item.editableByCompany,
                                            visibleForCompanies: item.visibleForCompanies,
                                            xpathMapping: item.xpathMapping,
                                            label: item.label,
                                            comments: item.comments,
                                            actions: (
                                                <div className="text-center">
                                                    <Button
                                                        onClick={() => {
                                                            let attribute = tableData.find(attr => attr.id === item.id);
                                                            this.setState({
                                                                modal: !this.state.modal,
                                                                newAttribute: attribute
                                                            });
                                                        }}
                                                        color="inverse"
                                                        size="sm"
                                                        round="true"
                                                        icon="true"
                                                    >
                                                        <i className="fa fa-edit"/>
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            this.isOkModalToggle(item.id)
                                                        }}
                                                        className="ml-1"
                                                        color="danger"
                                                        size="sm"
                                                        round="true"
                                                        icon="true"
                                                    >
                                                        <i className="fa fa-times"/>
                                                    </Button>
                                                </div>
                                            ),
                                            attr: item
                                        };
                                    });
                                    return (
                                        <ReactTable
                                            getProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    style: {
                                                        border: "none",
                                                        padding: "5px"
                                                    }
                                                };
                                            }}
                                            getTheadProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    style: {
                                                        boxShadow: "none",
                                                        padding: "10px 0",
                                                        fontWeight: "600"
                                                    }
                                                };
                                            }}
                                            getTheadThProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    style: {
                                                        borderRight: "none",
                                                        whiteSpace: "normal"
                                                    }
                                                };
                                            }}
                                            getTrProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    style: {
                                                        alignItems: "center"
                                                    }
                                                };
                                            }}
                                            getTdProps={(state, rowInfo, column, instance) => {
                                                return {
                                                    style: {
                                                        borderRight: "none",
                                                        textAlign: "center"
                                                    }
                                                };
                                            }}
                                            columns={[
                                                {
                                                    Header: "#",
                                                    // accessor: "index",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 40,
                                                    style: {
                                                        textAlign: "center",
                                                        fontSize: "12px",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    Cell: (row) => {
                                                        return <div>{row.index + 1}</div>;
                                                    }
                                                },
                                                {
                                                    Header: `${I18n[lang].tableTitle}`,
                                                    accessor: "name",
                                                    sortable: false,
                                                    filterable: false,
                                                    style: {
                                                        textAlign: "left"
                                                    }
                                                },
                                                {
                                                    Header: `${I18n[lang].view}`,
                                                    accessor: "type",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 100,
                                                },
                                                {
                                                    Header: `${I18n[lang].type}`,
                                                    accessor: "valueType",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 80
                                                },
                                                {
                                                    Header: `${I18n[lang].defaultValue}`,
                                                    accessor: "defaultValue",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 120

                                                },
                                                {
                                                    Header: `${I18n[lang].permittedValues}`,
                                                    accessor: "permittedValues",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 120,
                                                    Cell: row => (
                                                        <ul className='permitted-values'>
                                                            {
                                                                row.value.map((elem, i) => (
                                                                    <li key={i}>{elem}</li>))
                                                            }
                                                        </ul>
                                                    )
                                                },
                                                {
                                                    Header: `${I18n[lang].editable}`,
                                                    accessor: "editableByCompany",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 120,
                                                    Cell: row => (
                                                        <div>
                                                            {
                                                                row.value ?
                                                                    <i className="fas fa-check icon__added"/> : ""
                                                            }
                                                        </div>
                                                    )
                                                },
                                                {
                                                    Header: `${I18n[lang].companies}`,
                                                    accessor: "visibleForCompanies",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 85,
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    Cell: state => (
                                                        <div>
                                                            {
                                                                state.value && state.value.length ? (
                                                                    <Button
                                                                        title="Companies"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                newAttribute: state.row,
                                                                            }, () => {
                                                                                this.changeCompanyListView(COMPANIESMODALVIEWS.VIEW);
                                                                            })
                                                                        }}
                                                                        color="primary"
                                                                        size="sm"
                                                                        round="true"
                                                                        icon="true"
                                                                    >
                                                                        <i className="fas fa-building"/>
                                                                    </Button>
                                                                ) : 'All'
                                                            }
                                                        </div>
                                                    )


                                                },
                                                {
                                                    Header: `${I18n[lang].mapping}`,
                                                    accessor: "xpathMapping",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 200

                                                },
                                                {
                                                    Header: `${I18n[lang].comments}`,
                                                    accessor: "comments",
                                                    sortable: false,
                                                    filterable: false,
                                                },
                                                {
                                                    Header: "",
                                                    accessor: "actions",
                                                    sortable: false,
                                                    filterable: false,
                                                    maxWidth: 120
                                                },
                                            ]}
                                            PaginationComponent={Pagination}
                                            nextText={">>"}
                                            previousText={"<<"}
                                            pageSize={10}
                                            minRows={0}
                                            defaultPageSize={-1}
                                            showPaginationBottom={tableData.length  && tableData.length > 10 ? true : false}
                                            //pageSize={tableData.length}
                                            // showPaginationBottom={false}
                                            className="-highlight"
                                            data={tableData}
                                            filterable
                                        />
                                    )
                                }
                            })()
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchCompanies: query => dispatch(fetchCompanies(query)),
        fetchAttributes: query => dispatch(fetchAttributes(query)),
        filteringAttr: filter => dispatch(filteringAttr(filter)),
        saveNewAttribute: attribute => dispatch(saveNewAttribute(attribute)),
        updateOldAttribute: attribute => dispatch(updateOldAttribute(attribute)),
        deleteAttr: attributeId => dispatch(deleteAttr(attributeId)),
        closeAlert: () => dispatch(closeAlert())
    };
};

const mapStateToProps = state => ({
    companies: state.companiesReducer.companies,
    attributes: state.attributesList.attributes,
    filteredAttrs: state.filteredAttrsList.attributes,
    alert: state.alert,
    loading: state.attributesList.loading,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Attributes)



// WEBPACK FOOTER //
// ./src/components/Attributes/Attributes.js